/* es5-ext/array/#/clear.js */ function _(require, module, exports) {
    var value = require(10) /* ../../object/valid-value */;
    module.exports = function () {
        value(this).length = 0;
        return this;
    };
}
